export enum EColors {
    FOOTER_BLUE = "#5D6671",
    LIGHT_BLUE = "#EAF4FF",
    GREY_BLUE = "#F7F8F8",
    LUMINUM_BLUE = "#308EFE",
    DARK_BLUE = "#262E37",
    DIVIDER_BLUE = "#d7dadc",
}